module.exports = __webpack_public_path__ + "img/qrcode_chplay.c77a1b0e.png";